import React from 'react';

const NavBar = () => {
    return(
        <nav className="navbar">
            <div className="logo">
                <a className="navbar-brand" href="https://berkeley-gov.github.io/myportfolio.github.io/">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/International_Pok%C3%A9mon_logo.svg/269px-International_Pok%C3%A9mon_logo.svg.png" height="100%" alt="Pokemon logo" />
                </a>    
            </div>
        </nav>
    );
}

export default NavBar;